webpackJsonp([49683490770531],{

/***/ 346:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"excerpt":"Put recipe here","id":"/Applications/MAMP/htdocs/falkens-party-supplies/src/pages/blog-posts/non-stick-recipe.md absPath of file >>> MarkdownRemark","frontmatter":{"title":"Non-Stick Cookie Dough Recipe","image":"/images/ssl.jpg","date":"July 12, 2017","path":"/blog/non-stick-cookie-dough-recipe"}}}]}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-89c36b7bdc2145e6abd4.js